const server = 'https://www.miappaim.onecontrolcargosystem.com/';
// const server = 'http://mdev7.onecontrolcargosystem.com';

// const server = 'https://www.miapprp.onecontrolcargosystem.com';

const Api = {
  //   server: window.location.origin,
  login: server + '/manlogin.php',
  packs: server + '/listarpaqjson.php',
  office: server + '/misoficinajson.php',
  profile: server + '/misdatosjson.php',
  logout: server + '/logoff.php',
  uploadInvoice: server + '/mancargafactura.php',
  uploadInvoicePrealerta: server + '/mancargafacturaprealerta.php',
  prealertas: server + '/listarprealertajson.php',
  createPrealerta: server + '/manprealerta.php',
  createDeliveryRequest: server + '/mandomicilio.php',
  DeliveryRequest: server + '/listarpaqjsondomicilio.php',
  provincias: server + '/listprovinciasjson.php',
  oficinas: server + '/listoficinasjson.php',
  registro: server + '/manregistro.php',
  buscar: server + '/buscapaquetejson.php',
  // status: server + '/listarstatusjson.php',
  status: server + '/listarstatushomejson.php',
  listPackStatus: server + '/listarpaqdetallejson.php',
  listClaims: server + '/listarreclamacion.php',
  CreateClaims: server + '/crealistarreclamacion.php',
  CreateMessage: server + '/crealistarmensaje.php',
  listTypeClaims: server + '/listtiporeclamacion.php',
  listInvoice: server + '/listfacturaspendientes.php',
  TermsConditions: server + '/terminosycondicionespagina.php',
  slider: server + '/sliderjson.php',
  news: server + '/noticiasjson.php',
  domicilioInf: server + '/domicilioconfjson.php',
  history: server + '/listarpaqdetalleentregadojson.php',


}
export default Api